import { Link } from 'react-router-dom'
import { Icon } from '../../../share/Elements'
import classes from "./ManagementDashboardCard.module.scss";

type ManagementDashboardCardType = {
  title: string;
  icon: string;
  className?: string;
  iconClassName?: string;
  isCurrency?:boolean;
  count: number;
  href: string;
};

const ManagementDashboardCard: React.FC<ManagementDashboardCardType> = ({
  title,
  icon,
  className,
  iconClassName,
  isCurrency,
  count,
  href,
}) => {
   
  return (
    <div
      className={`p-2 border border-disable rounded-md flex flex-col
         justify-center items-end bg-white ${className}`}
    >
      <div className={classes["card-item"]}>
        <div className="w-full text-center">
          <div>{title}</div>
          {isCurrency ? (
            <div className={classes["count"]}>
              {count?.currency().toPersian()}
            </div>
          ) : (
            <div className={classes["count"]}>
              {count?.toString().toPersian()}
            </div>
          )}
        </div>
        <Icon icon={icon} className={`text-6xl ${iconClassName}`} />
        <Link to={href} className={classes["stretched-link"]} />
      </div>
      <div className={classes["footer"]}></div>
    </div>
  );
};
export default ManagementDashboardCard;
